import React, { useEffect, useState, useRef, useContext } from 'react';

import './PrincipalPage.css';
import * as Context from '../../context';
import PublicationsActions from '../../actions/PublicationsActions';
import Slider from 'react-slick';
import Loader from '../UI/Loader/Loader';
import { Mixpanel } from '../../utils';

const PrincipalPage = () => {
  const { backgroundUrl } = useContext(Context.BackgroundImage.BackgroundImageContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [skipCount, setSkipCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    const result = await PublicationsActions.GetAll(skipCount, 10);
    setData([...data, ...result.items]);
    setHasMore(result.totalCount > data.length + result.items.length);
    setLoading(false);
  }

  useEffect(() => {
    //fetchData();
  }, [skipCount]);

  useEffect(() => {
    Mixpanel.Track('View_PrincipalPage');
  }, []);

  if (loading && data.length === 0) return <Loader />;
  
  const onScroll = ({ target: { clientHeight, scrollTop, scrollHeight }}) => {
    const isBotttom = Math.ceil(clientHeight + scrollTop) >= scrollHeight;
    if (isBotttom && hasMore && !loading) {
      Mixpanel.Track('Scroll_PrincipalPage');
      setSkipCount(skipCount + 10);
    }
  }

  return (
    <div className="PrincipalPage" onScroll={onScroll}>
      <img src={backgroundUrl || ''}/>
      {/*data.length === 0 && true &&
        <h1 className="PrincipalPage__Text">
          Somos una comunidad dedicada al disfrute y respeto de la vida, nuestro hobby es hacer la mejor ropa del mundo.
        </h1>
      */}
      {/*data.map((item, index) => (
        <div
          key={index}
          className="PrincipalPage__Publication"
          style={item.images.length === 1 ? { minHeight: 'unset' } : null}
        >
          <PublicationSlider item={item} />
          <span className="Publication__Description">{item.description}</span>
          <hr className="Publication__HRDivider" />
        </div>
      ))*/}
      {/*data.length > 0 && loading &&
        <span className="fa fa-spin fa-spinner" />
      */}
    </div>
  );
}

function checkVisible(elm) {
  var rect = elm.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

const PublicationSlider = ({ item }) => {
  const [activeSlide, setActiveSlide] = useState(1);
  const sliderNumberEl = useRef(null);
  const afterChange = () => Mixpanel.Track('Swipe_PrincipalPage');
  const settings = {
    arrows: false,
    dots: true,
    infinite: false,
    lazyLoad: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange,
    beforeChange: (old, newIndex) => setActiveSlide(newIndex + 1)
  };
  useEffect(() => {
    if (sliderNumberEl.current && checkVisible(sliderNumberEl.current)) {
      sliderNumberEl.current.classList.remove('active');
      void sliderNumberEl.current.offsetWidth;
      sliderNumberEl.current.classList.add('active');
    }
  }, [activeSlide])

  return (
    <div className="Publication__Slider">
      {item.images.length > 1 &&
        <span className={`Slide__Number`} ref={sliderNumberEl}>{activeSlide}/{item.images.length}</span>}
      <Slider {...settings}>
        {item.images.map((image, index) =>
          <img alt="img" key={index} src={image.url} />
        )}
      </Slider>
    </div>
  )
}
export default PrincipalPage;